import styled from 'styled-components/macro';

export const StyledLogo = styled.img`
    width: 14rem;
    height: 4.1rem;
`;
